import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M19.5578 2.57436C20.1474 1.98628 20.1474 1.03027 19.5578 0.442191C18.9697 -0.147397 18.0152 -0.147397 17.4256 0.442191L10.0008 7.86708L2.57436 0.442191C1.98628 -0.147397 1.03027 -0.147397 0.442191 0.442191C-0.147397 1.03027 -0.147397 1.98628 0.442191 2.57436L7.86708 10.0008L0.442191 17.4256C-0.147397 18.0152 -0.147397 18.9697 0.442191 19.5578C1.03027 20.1474 1.98628 20.1474 2.57436 19.5578L10.0008 12.1329L17.4256 19.5578C18.0152 20.1474 18.9697 20.1474 19.5578 19.5578C20.1474 18.9697 20.1474 18.0152 19.5578 17.4256L12.1329 10.0008L19.5578 2.57436Z",
  fill: "#2B3951"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };